export const environment = {
    production: false,
    apiUrl: 'https://api-saveurs-dev.freedeve.com'
};